<template>
    <DashboardLayout>

        <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
            <p class="mb-0 main-identifier fw-semibold">Budget</p>
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
            <p class="mb-0 sub-identifier">View MDA Line Item</p>
        </div>

        <div class="d-flex justify-content-center">

            <div class="form-outer">
                    <div class="view-item  position-relative">

                        <div class="form-inner">
                            <div class="form-header d-flex justify-content-between align-items-center">
                                <h1 class="mb-0">MDA Line Item </h1>
                            </div>

                          <div class="form-body">
                            <div class="row list-wrapper">
                                <div class="col-md-12 row form-group position-relative floating-label-group list-blue">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Year:</label></div>
                                  <div class="col-md-6 input-right align-items-center">
                                    <p>2023</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group list-green">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">M.D.A:</label></div>
                                  <div class="col-md-6 input-right">
                                    <p>Ministry of Finance</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group list-blue">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Amount Budgeted:</label></div>
                                  <div class="col-md-6 input-right">
                                    <p>#10,000,000.00</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group list-green">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Amount Released:</label></div>
                                  <div class="col-md-6 input-right">
                                    <p>#10,000,000.00</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group list-blue">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Balance:</label></div>
                                  <div class="col-md-6 input-right">
                                    <p>#10,000,000.00</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group list-green">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Performance:</label></div>
                                  <div class="col-md-6 input-right">
                                    <p>90%</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group floating-label-group list-blue">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Economic Line Item:</label></div>
                                  <div class="col-md-6 input-right">
                                    <p>Laptop</p>
                                  </div>
                                  <div class="col-md-3 row input-right">
                                    <div class="col-md-6">
                                      <button class="btn btn-warning edit">Edit</button>
                                    </div>
                                    <div class="col-md-6">
                                      <button class="btn btn-danger delete">Delete</button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>


                    </div>
            </div>
        </div>

    </DashboardLayout>
</template>

<script setup>
import { onMounted } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'

const root_api_url = process.env.VUE_APP_API_ROOT_URL





const fetchEconomicLineItems = async () => {
  try {
    const response = await axios.get(`${root_api_url}/eli`)
    // subsectors.value =
    response.data
  } catch (err) {
    console.error('Error fetching economic line items:', err)
    // alert('Failed to load economic line items.')
  }
}

onMounted(() => {
  fetchEconomicLineItems,
    document.title = "View MDA Line Item"
})

</script>
